import React, { ReactNode } from "react";

import { WysiwygFormWidget, WysiwygFormWidgetProps } from "./WysiwygFormWidget";

export const wysiwygWidget = (props: WysiwygFormWidgetProps): ReactNode => {
  return <WysiwygFormWidget {...props} />;
};
